'use client'

import text from '@fukku/styles/texts.module.scss'
import { ClientLabel } from 'labels/client'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { cx } from 'utils/cx'
import type { DeliveryTime } from '../../../../../types/DeliveryTimes'
import styles from './SizeDelayedLabel.module.scss'

export interface SizeDelayedLabelProps {
	readonly delayedTime: DeliveryTime
	readonly showLastUnits: boolean
	readonly hasDelayRange?: boolean
}

export function SizeDelayedLabel({
	delayedTime,
	showLastUnits,
	hasDelayRange,
}: SizeDelayedLabelProps): React.ReactNode {
	const { t } = useLabels()

	return (
		<span
			className={cx(
				!!showLastUnits && text.bodySRegular,
				styles.sizeDelayedLabel
			)}
		>
			<ClientLabel
				placeholderValues={{
					1: hasDelayRange ? delayedTime.minimumTime : delayedTime.maximumTime,
					2: delayedTime.maximumTime,
				}}
			>
				{t(
					hasDelayRange
						? 'pdp.sizeSelector.shipmentInterval.text'
						: 'pdp.sizeSelector.shipmentDays.text'
				)}
			</ClientLabel>
		</span>
	)
}
